module.exports = __webpack_public_path__ + "media/bootstrap-icons/cone-striped-3d2fb0ee.svg";